// Interceptor de errores HTTP — manejo centralizado de errores de red y de API
import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

const SERVER_ERROR_ROUTE = '/cotizador/error/servidor';
const VERIFICATION_ERROR_ROUTE = '/cotizador/error/verificacion';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const flowEndRoute = resolveFlowEndRoute(req.method, req.url, error, router.url);
      if (flowEndRoute) {
        void router.navigate([flowEndRoute], {
          queryParams: { entry: 'landing' },
          replaceUrl: true,
        });
      }

      // Mantener el error HTTP original para no romper manejadores existentes.
      return throwError(() => error);
    }),
  );
};

function resolveFlowEndRoute(
  requestMethod: string,
  requestUrl: string,
  error: HttpErrorResponse,
  currentUrl: string,
) : string | null {
  if (error.status < 400) return null;
  if (!isApiRequest(requestUrl)) return null;
  if (isDocumentsUploadRequest(requestUrl)) return null;
  if (isVehicleLookupNotFound(requestUrl, error.status)) return null;
  if (currentUrl.startsWith(SERVER_ERROR_ROUTE) || currentUrl.startsWith(VERIFICATION_ERROR_ROUTE)) {
    return null;
  }

  if (isDataProtectionBadRequest(requestMethod, requestUrl, error.status)) {
    return VERIFICATION_ERROR_ROUTE;
  }

  return SERVER_ERROR_ROUTE;
}

function isDataProtectionBadRequest(method: string, url: string, status: number): boolean {
  if (status !== 400) return false;
  if (String(method ?? '').toUpperCase() !== 'POST') return false;

  const normalizedUrl = String(url ?? '').toLowerCase();
  return normalizedUrl.includes('/api/v1/clientes-cl/proteccion-datos');
}

function isApiRequest(url: string): boolean {
  const normalizedUrl = String(url ?? '').toLowerCase();
  const baseUrl = String(environment.baseUrlXapiCl ?? '').toLowerCase();

  if (baseUrl && normalizedUrl.startsWith(baseUrl)) {
    return true;
  }

  return normalizedUrl.includes('/api/');
}

function isVehicleLookupNotFound(url: string, status: number): boolean {
  if (status !== 404) return false;

  const normalizedUrl = String(url ?? '').toLowerCase();
  return normalizedUrl.includes('/vehiculos-cl/') || normalizedUrl.includes('/vehicle-cl/');
}

function isDocumentsUploadRequest(url: string): boolean {
  const normalizedUrl = String(url ?? '').toLowerCase();
  return normalizedUrl.includes('/api/v1/documentos');
}
